<template>
  <div id="app">
    <b-navbar toggleable="lg" type="dark" variant="info">
      <b-navbar-brand :href="getWrapHomeUrl()">
        <img class='nav-img' src='/img/logo.png' alt='logo'/>
      </b-navbar-brand>
      <b-navbar-nav>
        <b-nav-item href="/">
          <div class="text-left nav-bold-top-title">
            <span class='tenant-color'>{{ tenantName() }}</span> COMMUNITY ASSESSOR
          </div>
          <div class="text-left nav-bold-bottom-title">
            FIELD ASSESSMENT TOOL
          </div>
        </b-nav-item>
      </b-navbar-nav>
      <b-navbar-nav  class="ml-auto">
        <b-nav-item>
          <div v-if="isUserLoggedIn() && !isLoginPage()" class='welcome-text'>
            Welcome, {{ userLoggedIn }}
          </div>
        </b-nav-item>
      </b-navbar-nav>
    </b-navbar>
    <router-view/>
    <b-navbar v-bind:class="{ 'bottom-navbar': isLoginPage() }"
      toggleable="lg" type="dark" variant="info">
      <b-navbar-nav class="mr-auto">
        <div v-if="isUserLoggedIn() && !isLoginPage()">
          <b-button size="sm" class="my-2 my-sm-0"
            variant="primary" aria-label="Go To Community Assessor Tool"
            @click='goToCatOrShowConfirmationModal'>
            <font-awesome-icon icon="caret-left" class="button-icon" />
            Go to CAT
          </b-button>
        </div>
      </b-navbar-nav>
      <b-navbar-nav>
        <div class="version-number">{{ appVersion() }}</div>
      </b-navbar-nav>
      <b-navbar-nav class="ml-auto">
        <b-nav-item>
          <div v-if="isUserLoggedIn() && !isLoginPage()" class="text-right">
            <b-button size="sm" class="my-2 my-sm-0" variant="primary" type="submit"
              aria-label="Sign Out"
              @click='showSignOutConfirmationModal'>
              <font-awesome-icon icon="sign-out-alt" class="button-icon" />Sign Out
            </b-button>
          </div>
        </b-nav-item>
      </b-navbar-nav>
    </b-navbar>
  </div>
</template>

<script>

import { mapState } from 'vuex';
import helpers from '@/mixins/helpers';
import { createStore, del, clear } from 'idb-keyval';

export default {
  name: 'App',
  mixins: [helpers],
  computed: {
    ...mapState({
      loggedIn: (state) => state.loggedIn,
      userLoggedIn: (state) => state.userLoggedIn,
      communityAssessorUrl: (state) => state.config.communityAssessorUrl,
      wrapUrl: (state) => state.config.wrapUrl,
    }),
  },
  mounted() {
    window.addEventListener('offline', () => {
      this.$store.dispatch('setOffline');
      this.$store.dispatch('fetchCommunities');
      this.$store.dispatch('fetchProjects');
    });
    window.addEventListener('online', () => {
      this.$store.dispatch('setOnline');
      if (this.isLoggedOutAndOnline() && !this.isLoginPage()) {
        this.$router.push({ name: 'LogIn' });
      }
      this.$store.dispatch('fetchCommunities');
      this.$store.dispatch('fetchProjects');
    });
  },
  methods: {
    isLoginPage() {
      return this.$route.name === 'LogIn';
    },
    goToCatOrShowConfirmationModal() {
      if (!navigator.onLine) {
        const offlineMsg = 'You are currently offline. You must be connected to the internet '
        + 'to visit the Community Assessor website.';
        this.showOkModal(null, offlineMsg);
      } else {
        window.location.href = this.getCommunityAssessorHomeUrl();
      }
    },
    showSignOutConfirmationModal() {
      this.$bvModal.msgBoxConfirm(
        'For security reasons, when you sign out of the Field Assessment Tool, '
        + 'all of the downloaded and ad hoc communities and their assessments will be permanently deleted'
        + ' from this device. Are you sure you want to sign out?',
        {
          title: 'WARNING - You could lose data!',
          // size: 'sm',
          // buttonSize: 'sm',
          okVariant: 'success',
          okTitle: 'Yes',
          cancelTitle: 'No',
          cancelVariant: 'danger',
          // footerClass: 'p-2',
          hideHeaderClose: true,
          centered: true,
        },
      ).then((userClickedYes) => {
        if (userClickedYes) {
          this.signOut();
        }
      });
    },
    signOut() {
      localStorage.removeItem('access_token');
      localStorage.removeItem('userLoggedIn');
      // remove all custom stores
      let customStore = createStore('fieldToolAccess', 'access');
      del('access_token', customStore);
      del('userLoggedIn', customStore);
      customStore = createStore('fieldToolCommunities', 'communities');
      clear(customStore);
      customStore = createStore('fieldToolCategories', 'assessmentCategories');
      clear(customStore);
      customStore = createStore('fieldToolFireDepartments', 'fireDepartments');
      clear(customStore);
      customStore = createStore('fieldToolAssessModel', 'assessment_model');
      clear(customStore);
      customStore = createStore('fieldToolProjects', 'projects');
      clear(customStore);
      customStore = createStore('fieldToolConfig', 'config');
      clear(customStore);
      this.$store.dispatch('LogOut').then(() => {
        this.$router.push({ name: 'LogIn' });
      });
    },
    tenantName() {
      return process.env.VUE_APP_TENANT_NAME;
    },
    appVersion() {
      return process.env.VUE_APP_GIT_HASH;
    },
    getCommunityAssessorHomeUrl() {
      return `${this.communityAssessorUrl}/Home/Index`;
    },
    getWrapHomeUrl() {
      return `${this.wrapUrl}`;
    },
  },
};
</script>
